import _ from 'lodash'
import { useTranslation } from 'react-i18next'

import { Card } from '@mui/material'

import Tabs from '@/components/ui/tabs/Tabs'
import TabPanel from '@/components/ui/tab/TabPanel'

import ConsultationsCard from './ConsultationsCard'
import ExpertisesCard from './ExpertisesCard'

export function ExpertiseAndConsultationsTab() {
  const { t } = useTranslation()

  return (
    <Card sx={{ height: '100%', padingBottom: 10 }}>
      <Tabs
        renderTabPanel={({ value }) => (
          <>
            <TabPanel value={value} index={0}>
              <ConsultationsCard sx={{ boxShadow: 'none' }} />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <ExpertisesCard sx={{ boxShadow: 'none' }} />
            </TabPanel>
          </>
        )}
        tabs={_.compact([
          { label: t('page.home.consultations.title'), sx: { fontWeight: 700 } },
          { label: t('page.home.expertises.title'), sx: { fontWeight: 700 } },
        ])}
        variant="fullWidth"
      />
    </Card>
  )
}

export default ExpertiseAndConsultationsTab
